import React from 'react';

/**
 * Filtrar a tabela a cada tecla digitada refaz a lista inteira; com frota grande, os primeiros
 * caracteres sao os piores, porque quase nada e descartado e quase tudo e redesenhado. O campo so
 * entrega o termo a partir do minimo -- abaixo disso responde vazio, que e o mesmo que nao filtrar.
 *
 * A tabela le o termo pelo metodo getValue desta instancia, e nao pelo evento, entao e aqui que o
 * limite precisa morar. setValue existe porque o botao de limpar chama esse metodo.
 */
class SearchField extends React.Component {
    constructor(props) {
        super(props);
        this.value = props.defaultValue || '';
        this.state = {incompleto: false};
        this.input = null;
    }

    getValue() {
        return this.value.length >= this.props.minLength ? this.value : '';
    }

    setValue(value) {
        this.value = value;
        if (this.input) this.input.value = value;
        this.setState({incompleto: false});
    }

    handleChange = (event) => {
        this.value = event.target.value;
        this.setState({incompleto: this.value.length > 0 && this.value.length < this.props.minLength});
    };

    render() {
        const {placeholder, defaultValue, search, minLength, hint} = this.props;

        return (
            <div className="react-bs-table-search-form">
                <input
                    ref={(node) => (this.input = node)}
                    className="form-control"
                    type="text"
                    defaultValue={defaultValue}
                    placeholder={placeholder}
                    onChange={this.handleChange}
                    onKeyUp={search}
                />
                {this.state.incompleto && (
                    <small className="text-muted d-block mt-1">{hint(minLength)}</small>
                )}
            </div>
        );
    }
}

export default SearchField;
